module.exports = __webpack_public_path__ + "img/安徽政务服务网.51cf3d74.png";